<template>
  <div class="pa-3 pt-0 d-flex flex-column body-2 therapies-card">
    <div
      v-if="loading"
      class="d-flex justify-center align-center"
      style="min-height: 262px"
    >
      <hollow-dots-spinner
        :animation-duration="1000"
        :dot-size="20"
        :dots-num="3"
        color="#099845"
      />
    </div>
    <v-list
      v-else-if="therapies && therapies.length > 0"
      class="pa-5 pt-0 body-2 mb-3"
    >
      <v-list-item
        v-for="therapy in therapies"
        :key="therapy.id"
        class="border-bottom-grey"
      >
        <v-list-item-avatar style="min-width: 50px">
          <tooltip-icon
            v-show="
              getStatusIcon(therapy.status) &&
              getStatusIcon(therapy.status).condition
            "
            :color="getStatusIcon(therapy.status).color"
            :icon="getStatusIcon(therapy.status).icon"
            :text="getStatusIcon(therapy.status).text"
            :large="false"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ therapy[fieldName] }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ formatStatus(therapy.status) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          {{ therapy.date | formatDateTime }}
        </v-list-item-action>
        <v-list-item-action>
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon x-small v-bind="attrs" v-on="on" @click.stop>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <!-- VER DIAGNÓSTICO - Apenas se SYNCED -->
              <template v-if="therapy.status === 'SYNCED'">
                <v-list-item @click="viewDiagnosis(therapy)">
                  <v-list-item-title>
                    <v-icon small class="mr-2">pageview</v-icon>
                    Ver diagnóstico
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
              </template>

              <!-- CONTINUAR TERAPIA - Apenas se DRAFT -->
              <template v-if="therapy.status === 'DRAFT'">
                <v-list-item @click="resumeTherapy(therapy)">
                  <v-list-item-title>
                    <v-icon small class="mr-2">redo</v-icon>
                    Continuar terapia
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
              </template>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
      <v-list-item :to="{ name: nameRouteDetailed }">
        <v-list-item-content
          class="font-weight-bold secondary--text text-decoration-underline"
        >
          Ver histórico completo
        </v-list-item-content>
        <v-list-item-action>
          <v-icon color="secondary">arrow_forward</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <empty-list
      v-else
      class="pa-3"
      text="Nenhum dado disponível para mostrar"
    />
  </div>
</template>

<script>
export default {
  name: "SimplifiedTherapiesList",
  components: {
    HollowDotsSpinner: () =>
      import("epic-spinners").then((m) => m.HollowDotsSpinner),
  },
  props: {
    therapies: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      default: "patientName",
    },
    nameRouteDetailed: {
      type: String,
      required: true,
    },
  },
  computed: {
    loading() {
      return this.isLoading;
    },
  },
  methods: {
    formatStatus(status) {
      if (!status) return "Em preenchimento";
      const map = {
        SYNCED: "Terapia Finalizada",
        IN_QUEUE: "Em fila de processamento",
        IN_QUEUE_WITH_ERROR: "Erro ao realizar processamento",
        DRAFT: "Terapia em preenchimento",
      };
      return map[status] || status;
    },
    getStatusIcon(status) {
      const icons = {
        SYNCED: {
          icon: "check_circle",
          color: "primary",
          text: "Processado",
          condition: true,
        },
        IN_QUEUE: {
          icon: "playlist_add_check",
          color: "info",
          text: "Na fila para processamento",
          condition: true,
        },
        IN_QUEUE_WITH_ERROR: {
          icon: "sync_problem",
          color: "error",
          text: "Erro ao realizar processamento",
          condition: true,
        },
        DRAFT: {
          icon: "cloud_upload",
          color: "info",
          text: "Em preenchimento (salvo na nuvem)",
          condition: true,
        },
      };
      return icons[status] || { condition: false };
    },
    viewDiagnosis(therapy) {
      // Emitir evento para o componente pai ir para a página de diagnóstico
      this.$emit("view-diagnosis", therapy);
    },
    resumeTherapy(therapy) {
      // Emitir evento para o componente pai continuar a terapia
      this.$emit("resume-therapy", therapy);
    },
  },
};
</script>

<style scoped>
.therapies-card {
  min-height: 262px;
  justify-content: center;
}
</style>
